import { type SelectTypes } from '@uikit/form/select';

const filterSelectedOptions = (options: SelectTypes.Option[], selectedOptions: Set<SelectTypes.Option['value']>) =>
    options.filter(({ value }) => !selectedOptions.has(value));

export function getVisibleOptionsGroups(
    optionsGroups: SelectTypes.OptionsGroup[] = [],
    selectedOptions: SelectTypes.Option[],
) {
    const selectedOptionsSet = new Set(selectedOptions.map(({ value }) => value));

    return optionsGroups.map(({ options, ...rest }) => ({
        options: filterSelectedOptions(options, selectedOptionsSet),
        ...rest,
    }));
}

export function highlightMatchedOptionsLabels(value: string, options: SelectTypes.Option[] = []) {
    const valueRegExp = new RegExp(value, 'gi');

    return options
        .filter(({ label }) => label.search(valueRegExp) !== -1)
        .map(({ label, ...rest }) => {
            const match = label.search(valueRegExp);
            const decoratedLabel =
                label.slice(0, match) +
                `<b>${label.slice(match, match + value.length)}</b>` +
                label.slice(match + value.length);

            return {
                ...rest,
                label,
                decoratedLabel,
            };
        });
}
